<script>
  import { createEventDispatcher, onMount } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import Textarea from '@components/Textarea.svelte';
  import Input from '@components/Input.svelte';
  import Avatar from '@components/Avatar.svelte';
  import Notification from '@utils/notification';
  import DesignPaletteModal from './DesignPaletteModal.svelte';
  import WelcomeNoteAjax from '@ajax/welcome_note';

  import Doka from '@utils/doka';
  import store2 from 'store2';

  import jQuery from 'jquery';
  const dispatch = createEventDispatcher();

  export let group;
  export let mobile = false;
  export let edit = false;
  export let previewOnly = false;
  export let groupContext = false;

  let note;
  let editableNote;
  let loading = false;
  let saving = false;
  let showDesignPaletteModal = false;
  let showContainerDesignModal = false;
  let isIOS = false;

  let designPaletteCssProperty;
  let designPaletteFontCategories;

  let editableCombinedNoteCss = '';
  let editableCombinedSignatureCss = '';
  let editableCombinedContainerCss = '';
  let combinedNoteCss = '';
  let combinedSignatureCss = '';
  let combinedContainerCss = '';

  let fontSizes = {
    note_css_configuration: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
    signature_css_configuration: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
  };

  let close = function () {
    note = undefined;
    editableNote = undefined;
    loading = false;
    saving = false;
    combinedNoteCss = '';
    combinedSignatureCss = '';
    combinedContainerCss = '';
    editableCombinedNoteCss = '';
    editableCombinedSignatureCss = '';
    editableCombinedContainerCss = '';
    showDesignPaletteModal = false;
    dispatch('close');
  };

  let detectIOS = function () {
    isIOS =
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  };

  const welcomeNoteSeen = function (note) {
    let welcomeCookie = getWelcomeNoteCookies();
    let versionViewed = (welcomeCookie && welcomeCookie['version']) || 0;
    let id = (welcomeCookie && welcomeCookie['id']) || null;
    return note.id == id && versionViewed >= note.version;
  };

  const getWelcomeNoteCookies = function () {
    try {
      return store2(`${group.id}-welcome-note`);
    } catch {
      return {};
    }
  };

  const setWelcomeNoteCookies = function (note) {
    if (note) {
      store2(`${group.id}-welcome-note`, {
        id: note.id,
        version: note.version,
      });
    }
  };

  let save = async function () {
    if (saving == true) {
      return;
    }

    saving = true;

    try {
      note = await WelcomeNoteAjax.update(group, editableNote, editableNote);
      editableNote = jQuery.extend(true, {}, note);
      recomputeComputedStyles();

      Notification.send({
        text: 'Welcome note has been saved!',
      });

      saving = false;
      switchToViewMode();
    } catch (err) {
      if (err && err.full_errors) {
        Notification.send({
          text: err.full_errors[0],
          type: 'error',
        });
      }
    }

    saving = false;
  };

  let openContainerDesignModal = function () {
    closeContainerDesignModal();
    closeDesignPaletteModal();

    showContainerDesignModal = true;
  };

  let closeContainerDesignModal = function () {
    showContainerDesignModal = false;
  };

  let openDesignPaletteModal = function (css_prop) {
    return function () {
      closeDesignPaletteModal();
      closeContainerDesignModal();

      if (css_prop == 'note_css_configuration') {
        designPaletteFontCategories = undefined;
      } else if (css_prop == 'signature_css_configuration') {
        designPaletteFontCategories = ['handwriting'];
      }

      designPaletteCssProperty = css_prop;
      showDesignPaletteModal = true;
    };
  };

  let closeDesignPaletteModal = function () {
    designPaletteCssProperty = undefined;
    showDesignPaletteModal = false;
  };

  let switchToViewMode = function () {
    edit = false;
    showDesignPaletteModal = false;
    designPaletteCssProperty = undefined;
  };

  let switchToEditMode = function () {
    if (mobile) {
      Notification.send({
        text: 'Please use a larger screen to edit this welcome note',
      });
    } else {
      edit = true;
    }
  };

  let combineCssConfiguration = function (cssConfiguration) {
    var data = [];

    for (var key in cssConfiguration) {
      if (key == 'font-family') {
        data.push(`${key}: '${cssConfiguration[key]}'`);
      } else {
        data.push(`${key}: ${cssConfiguration[key]}`);
      }
    }

    return data.join('; ');
  };

  let recomputeComputedStyles = function () {
    combinedNoteCss = combineCssConfiguration(note.note_css_configuration);
    combinedSignatureCss = combineCssConfiguration(note.signature_css_configuration);
    combinedContainerCss = combineCssConfiguration(note.container_css_configuration);

    editableCombinedNoteCss = combineCssConfiguration(editableNote.note_css_configuration);
    editableCombinedSignatureCss = combineCssConfiguration(editableNote.signature_css_configuration);
    editableCombinedContainerCss = combineCssConfiguration(editableNote.container_css_configuration);
  };

  let loadFonts = async function () {
    const WebFont = await import('webfontloader');

    var noteFont = note.note_css_configuration['font-family'];
    var signatureFont = note.signature_css_configuration['font-family'];

    let fonts = [signatureFont];

    if (noteFont !== 'Helvetica Neue') {
      fonts.push(noteFont);
    }

    return new Promise((resolve, _reject) => {
      WebFont.load({
        google: {
          families: fonts,
        },
        active: function () {
          resolve();
        },
        inactive: function () {
          resolve();
        },
      });
    });
  };

  let fetchWelcomeNote = async function () {
    loading = true;

    try {
      note = await WelcomeNoteAjax.get(group, { withErrorHandling: false });

      if (!groupContext || !welcomeNoteSeen(note)) {
        editableNote = jQuery.extend(true, {}, note);
        await loadFonts();
        recomputeComputedStyles();

        if (groupContext) {
          setWelcomeNoteCookies(note);
        }
      } else {
        note = undefined;
        dispatch('close');
      }
    } catch {}

    loading = false;
  };

  let getConstractColor = function (hex) {
    try {
      var threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */
      let lastChar;

      const hexToR = (h) => {
        return parseInt(cutHex(h).substring(0, 2), 16);
      };
      const hexToG = (h) => {
        return parseInt(cutHex(h).substring(2, 4), 16);
      };
      const hexToB = (h) => {
        return parseInt(cutHex(h).substring(4, 6), 16);
      };
      const cutHex = (h) => {
        return h.charAt(0) == '#' ? h.substring(1, 7) : h;
      };

      if (hex == null || hex == undefined || hex == '') {
        hex = '#ffffff';
      }

      if (hex.length > 0 && hex[0] == '#' && hex.length < 7) {
        lastChar = hex[hex.length - 1];
        while (hex.length < 7) {
          hex += lastChar;
        }
      }

      if (hex.length > 0 && hex[0] != '#' && hex.length < 6) {
        lastChar = hex[hex.length - 1];
        while (hex.length < 6) {
          hex += lastChar;
        }
      }

      var hRed = hexToR(hex);
      var hGreen = hexToG(hex);
      var hBlue = hexToB(hex);

      var cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return '#000000';
      } else {
        return '#ffffff';
      }
    } catch {
      return '#000000';
    }
  };

  onMount(() => {
    fetchWelcomeNote();
  });

  detectIOS();
</script>

<style style="text/scss" lang="scss">
  .edit-note-link {
    color: #8e71ff;

    &:hover {
      color: #7054dc;
    }
  }

  .ui-actions {
    margin-top: 45px;
    margin-bottom: -2em;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .save-btn {
      height: 48px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #8e71ff;
      width: 275px;

      &:hover {
        background: #7054dc;
      }
    }

    .cancel-btn {
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  * :global(.border-radius-20) {
    border-radius: 20px !important;
  }

  * :global(.modal__container) {
    position: relative;
  }

  .delete-button {
    margin-top: 5px;
    cursor: pointer;
    color: #8e71ff;
    &:hover {
      color: #7054dc;
    }
  }
</style>

<link href="https://fonts.googleapis.com/css2?family=Marck+Script&display=swap" rel="stylesheet" />

{#if note}
  <div class="svelte-modal-layer">
    {#if edit}
      {#if editableNote}
        {#each [designPaletteCssProperty] as cssProperty (cssProperty)}
          <DesignPaletteModal
            mobile={mobile}
            bind:cssConfiguration={editableNote[cssProperty]}
            bind:showModal={showDesignPaletteModal}
            fontCategories={designPaletteFontCategories}
            fontSizes={fontSizes[cssProperty]}
            on:change={() => {
              recomputeComputedStyles();
            }} />
        {/each}

        <DesignPaletteModal
          mobile={mobile}
          showFontFamily={false}
          showFontWeight={false}
          showFontSize={false}
          fontColorLabel={'Background color'}
          fontColorAttr="background-color"
          bind:cssConfiguration={editableNote.container_css_configuration}
          bind:showModal={showContainerDesignModal}
          on:change={() => {
            recomputeComputedStyles();
          }} />
      {/if}

      <!-- edit -->
      <Modal
        mobile={mobile}
        on:close={close}
        show={true}
        showCloseButton={false}
        fadeInDuration={200}
        style="width: 580px; overflow-x: hidden; {editableCombinedContainerCss}">
        <div
          slot="content"
          style="text-align: center;"
          on:click={() => {
            closeDesignPaletteModal();
            closeContainerDesignModal();
          }}>
          {#if loading}
            <div style="color: #a893f9">
              <i class="fa fa-spin fa-spinner" />
              <span style="margin-left: 10px;">Loading</span>
            </div>
          {:else}
            <a
              on:click|preventDefault|stopPropagation={openContainerDesignModal}
              href="#"
              style="display: flex; align-items: center; margin-bottom: 30px;
            margin-top: -20px; width: 100%; text-align: left; color: #A893F9;
            font-size: 16px;">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <rect width="16" height="16" fill="url(#pattern0)" />
                <defs>
                  <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0" transform="scale(0.00195312)" />
                  </pattern>
                  <image
                    id="image0"
                    width="512"
                    height="512"
                    xlink:href="data:image/png;base64,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" />
                </defs>
              </svg>
              <span style="margin-left: 10px;">Background color</span>
            </a>
            <div style="display: flex; flex-direction: column; align-items: center;">
              <div>
                <Avatar
                  class="border-radius-20"
                  cropper={Doka().create({
                    utils: ['crop'],
                    cropAspectRatio: 0.36,
                    onloaderror: function (x) {
                      console.log(x);
                    },
                  })}
                  plusIcon={false}
                  showPlusIconWhenNoSrc={true}
                  src={editableNote.logo_url}
                  showBorder={false}
                  allowImageUpload={true}
                  width={413}
                  height={148}
                  mobile={mobile}
                  on:upload-complete={(e) => {
                    editableNote.logo_url = e.detail.images[0].response.uploadURL;
                  }}>
                  <div slot="empty">
                    <div
                      style="width: 413px; height: 148px; background: #F9F6FF;
                    border: 2px dashed #ECECEC; border-radius: 20px; display:
                    flex; flex-direction: column; justify-content: center;
                    align-items: center;">
                      <img src="/images/welcome-note/upload.svg" />

                      <div
                        style="margin-top: 16px; font-weight: 500; font-size:
                      16px; line-height: 18px; color: #1a1a1a;">
                        Upload photo or logo
                      </div>
                    </div>
                  </div>
                </Avatar>
              </div>
              {#if editableNote.logo_url}
                <div
                  class="delete-button"
                  on:click={() => {
                    editableNote.logo_url = null;
                  }}>
                  Delete
                </div>
              {/if}
              <div style="margin-bottom: 64px;" />
              <div style="width: 100%">
                {#each [editableCombinedNoteCss] as css (css)}
                  <Textarea
                    on:click={(e) => {
                      e.detail.event.stopPropagation();
                    }}
                    textareaStyle="{editableCombinedNoteCss}; background:
                  transparent; max-width: 413px; width: 100%;"
                    rows={5}
                    bind:value={editableNote.note}
                    on:focus={openDesignPaletteModal('note_css_configuration')} />
                {/each}
              </div>
              <div style="width: 100%; display: flex; align-items: center">
                <div style="flex: 1" />
                <div style="flex-shrink: 0; margin-right: 25px;">
                  <div>
                    <Avatar
                      src={editableNote.signature_image_url}
                      width={64}
                      showPlusIconWhenNoSrc={true}
                      allowImageUpload={true}
                      mobile={mobile}
                      on:upload-complete={(e) => {
                        editableNote.signature_image_url = e.detail.images[0].response.uploadURL;
                      }}>
                      <div slot="empty">
                        <div
                          style="width: 64px; height: 64px; background: #F9F6FF;
                      border: 1px dashed #ECECEC; border-radius: 9999px;
                      display: flex; flex-direction: column; justify-content:
                      center; align-items: center;">
                          <img src="/images/welcome-note/upload-avatar.svg" />
                        </div>
                      </div>
                    </Avatar>
                  </div>
                  {#if editableNote.signature_image_url}
                    <div
                      class="delete-button"
                      on:click={() => {
                        editableNote.signature_image_url = null;
                      }}>
                      Delete
                    </div>
                  {/if}
                </div>
                <div style="flex-shrink: 0;">
                  {#each [editableCombinedSignatureCss] as css (css)}
                    <Input
                      on:click={(e) => {
                        e.detail.event.stopPropagation();
                      }}
                      on:focus={openDesignPaletteModal('signature_css_configuration')}
                      bind:value={editableNote.signature}
                      inputStyle="{css}; background:
                    transparent;" />
                  {/each}
                </div>
              </div>
            </div>

            <div class="ui-actions">
              <button class="save-btn" on:click|preventDefault={save}>
                {#if saving}
                  <div>
                    <i class="fa fa-spin fa-spinner" />
                    <span style="margin-left: 10px;">Saving</span>
                  </div>
                {:else}Save{/if}
              </button>
              <button
                style="color: {getConstractColor(editableNote.container_css_configuration['background-color'])}"
                class="cancel-btn"
                on:click|preventDefault={switchToViewMode}>
                Cancel
              </button>
            </div>
          {/if}
        </div>
      </Modal>
    {:else}
      <!-- view -->
      <Modal
        mobile={mobile}
        on:close={close}
        show={true}
        showCloseButton={true}
        fadeInDuration={200}
        modalContentStyle={mobile ? 'margin-top: 0px !important;' : ''}
        closeButtonStyle="color: {getConstractColor(note.container_css_configuration['background-color'])};
      {mobile && isIOS ? 'font-size: 24px;' : ''};"
        overlayStyle={mobile ? 'padding-left: 20px; padding-right: 20px' : ''}
        style="border-radius: 16px; width: 580px; overflow-x: hidden; {mobile
          ? 'zoom: 0.9; padding-left: 40px !important; padding-right: 40px !important;'
          : ''}
      {combinedContainerCss}">
        <div slot="content" style="text-align: center;">
          {#if loading}
            <div style="color: #a893f9">
              <i class="fa fa-spin fa-spinner" />
              <span style="margin-left: 10px;">Loading</span>
            </div>
          {:else}
            {#if previewOnly == false && note.permissions.edit}
              <div
                style="position: absolute; {mobile ? 'right: 90px; top: 24px;' : 'right: 85px; top: 34px;'}
              {mobile && isIOS ? 'right: 120px; top: 107px;' : ''}">
                <a class="edit-note-link" href="#" on:click|preventDefault={switchToEditMode}> Edit note </a>
              </div>
            {/if}
            {#if note.logo_url}
              <div style="margin-bottom: 64px;">
                <img
                  src={note.logo_url}
                  style="width: 100%; max-width: 413px; max-height: 148px;
                border-radius: 20px; object-fit: cover;" />
              </div>
            {/if}
            <div
              style="white-space: pre-wrap; width: calc(100% - 20px); max-width:
            413px; width: 100%; margin-left: auto; margin-right: auto; {combinedNoteCss}">
              {note.note}
            </div>
            <div
              style="margin-top: 40px; display: flex; align-items: center;
            max-width: 413px; width: 100%; margin-left: auto; margin-right:
            auto;">
              <div style="flex: 1" />
              {#if note.signature_image_url}
                <div style="flex-shrink: 0; margin-right: 25px;">
                  <Avatar src={note.signature_image_url} width={64} style="cursor: unset" />
                </div>
              {/if}
              <div style="flex-shrink: 0; {combinedSignatureCss}">
                {note.signature}
              </div>
            </div>
          {/if}
        </div>
      </Modal>
    {/if}
  </div>
{/if}
